import { ISetNewUserSettingsPayload } from "@payment/providers/CheckoutProvider/dtos";

export const savePaymentDetails = (
  data,
  setNewUserSettings: (payload: ISetNewUserSettingsPayload) => Promise<void>,
) => {
  const {
    phone_number,
    display_name,
    type_entity,
    address_id,
    first_name,
    last_name,
    document,
    card_id,
    email,
    type,
  } = data;

  const newObject = {
    document_type: type,
    type_entity,
    document,
    type,
  };

  if (display_name) newObject["display_name"] = display_name;
  if (first_name) newObject["first_name"] = first_name;
  if (last_name) newObject["last_name"] = last_name;

  if (phone_number) newObject["phone"] = phone_number;
  if (email) newObject["email"] = email;

  if (address_id) newObject["address_id"] = address_id;
  if (card_id) newObject["card_id"] = card_id;

  const key = [];
  const value = [];
  const group = [];

  Object.entries(newObject).forEach(([Key, Value]) => {
    if (!!Value) {
      key.push(Key);
      value.push(Value);
      group.push("payment");
    }
  });

  setNewUserSettings({ key, group, value });
};
